module.exports = __webpack_public_path__ + "img/group-3-copy-8@3x.e1b1881c.jpg";